import { useListStorageLocationsQuery } from '../../redux/api/locationApi';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const StorageSelector = ({ storageLocation, setStorageLocation }) => {
  const curEvent = useSelector((state) => state.auth.currentEvent);
  // The list is scoped to the selected event server-side, so it only ever
  // contains valid choices for the current event.
  const { data: storageLocations } = useListStorageLocationsQuery(curEvent?.id, {
    skip: !curEvent?.id,
  });

  // Keep the selected value valid for the current event: auto-select the first
  // location, reset when the event changes, and clear when there are none.
  // Without this the control could hold an id that isn't among the rendered
  // options and silently submit it.
  useEffect(() => {
    const locations = storageLocations ?? [];
    const isValid = locations.some((st) => st.id === storageLocation);
    if (!isValid) {
      setStorageLocation(locations[0]?.id ?? null);
    }
  }, [storageLocations, storageLocation, setStorageLocation]);

  if (!storageLocations) {
    return null;
  }

  return (
    <select
      id='storageLocation'
      className='form-select'
      value={storageLocation ?? ''}
      disabled={storageLocations.length === 0}
      onChange={(e) => setStorageLocation(e.target.value)}
    >
      {storageLocations.length === 0 ? (
        <option value=''>Kein Lagerort für dieses Event</option>
      ) : (
        storageLocations.map((location) => (
          <option key={location.id} value={location.id}>
            {location.name}
          </option>
        ))
      )}
    </select>
  );
};

export default StorageSelector;
